export default __webpack_public_path__ + "static/egp4-23f4d68c7f840cf54ed0585562acdeea.jpg";